import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { darkLogo } from "../assets/index";
import { RotatingLines } from 'react-loader-spinner';
import { motion } from 'framer-motion';

const Registration = () => {
    //React-router-dom hook to change location
    const navigate = useNavigate();
    const auth = getAuth();

    //client registration information
    const [clientName, setClientName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    //error messages
    const [errClientName, setErrClientName] = useState("");
    const [errEmail, setErrEmail] = useState("");
    const [errPassword, setErrPassword] = useState("");
    const [errConfirmPassword, setErrConfirmPassword] = useState("");
    const [firebaseErr, setFirebaseErr] = useState('');

    //loading state for spinner conditional render
    const [loading, setLoading] = useState(false);
    //successMessage state for it's conditional render
    const [successMsg, setSuccessMsg] = useState('');

    //handle functions
    const handleName = (e) => {
        setClientName(e.target.value);
        setErrClientName("");
    };
    const handleEmail = (e) => {
        setEmail(e.target.value);
        setErrEmail("");
    };
    const handlePassword = (e) => {
        setPassword(e.target.value);
        setErrPassword("");
    };
    const handleCPassword = (e) => {
        setConfirmPassword(e.target.value);
        setErrConfirmPassword("");
    };

    //email validation over regex
    const emailValidation = (email) => {
        return String(email)
        .toLowerCase()
        .match(/^\w+([-]?\w+)*@\w+([-]?\w+)*(\.\w{2,3})+$/);
    };

    //submit button registration function
    const handleRegistration = (e) => {
        e.preventDefault();
        if (!clientName) {
            setErrClientName("Enter your name");
        }
        if (!email) {
            setErrEmail("Enter your email");
        } else {
            if (!emailValidation(email)) {
                setErrEmail("Enter a valid email");
                setFirebaseErr('');
            }
        }
        if (!password) {
            setErrPassword("Enter your password");
        } else {
            if (password.length < 6) {
                setErrPassword("Passwords must be at least 6 characters");
            }
        }
        if (!confirmPassword) {
            setErrConfirmPassword("Confirm your password");
        } else {
            if (confirmPassword !== password) {
                setErrConfirmPassword("Password not matched");
            }
    };

        if (
            clientName &&
            email &&
            emailValidation(email) &&
            password &&
            password.length >= 6 &&
            confirmPassword &&
            confirmPassword === password
            ) {
                setLoading(true);
                //Firebase Registration function
                createUserWithEmailAndPassword(auth, email, password)
                    .then((userCredential) => {
                        //adding clientName to the user's data in Firebase DB
                        updateProfile(auth.currentUser,{
                            displayName: clientName
                        })
                        const user = userCredential.user;
                        setLoading(false);
                        setSuccessMsg('Account Created Successfully!');
                        setTimeout(()=>{
                            navigate('/signin')
                        }, 3000);
                    }).catch((error) => {
                        const errorCode = error.code;
                        if(errorCode.includes('auth/email-already-in-use')){
                            setFirebaseErr('Email already in use, try another one');
                            setLoading(false);
                        }
                    });

                setClientName("");
                setEmail("");
                setPassword("");
                setConfirmPassword("");
                setErrConfirmPassword("");
                setFirebaseErr('');
            };
    };
    return (
        <div className="w-full">
        <div className="w-full bg-gray-100 pb-10">
            <form className="w-[370px] mx-auto flex flex-col items-center">
            <Link to="/">
                <img className="w-32" src={darkLogo} alt="darkLogo" />
            </Link>
            <div className="w-full border border-zinc-200 p-6">
                <h2 className="font-titleFont text-3xl font-medium mb-4">
                Create Account
                </h2>
                <div className="flex flex-col gap-3">
                <div className="flex flex-col gap-2">
                    <p className="text-sm font-medium">Your name</p>
                    <input
                    onChange={handleName}
                    value={clientName}
                    type="text"
                    className="w-full py-1 border border-zinc-400 px-2 text-base rounded-sm outline-none focus-within:border-[#e77600] focus-within:shadow-amazonInput duration-100"
                    />
                    {errClientName && (
                    <p className="text-red-600 text-xs font-semibold tracking-wide flex items-center gap-2 -mt-1.5">
                        <span className="italic font-titleFont font-extrabold text-base">
                        !
                        </span>
                        {errClientName}
                    </p>
                    )}
                </div>
                <div className="flex flex-col gap-2">
                    <p className="text-sm font-medium">
                    Email or mobile phone number
                    </p>
                    <input
                    onChange={handleEmail}
                    value={email}
                    type="email"
                    className="w-full lowercase py-1 border border-zinc-400 px-2 text-base rounded-sm outline-none focus-within:border-[#e77600] focus-within:shadow-amazonInput duration-100"
                    />
                    {errEmail && (
                    <p className="text-red-600 text-xs font-semibold tracking-wide flex items-center gap-2 -mt-1.5">
                        <span className="italic font-titleFont font-extrabold text-base">
                        !
                        </span>
                        {errEmail}
                    </p>
                    )}
                    {firebaseErr && (
                    <p className="text-red-600 text-xs font-semibold tracking-wide flex items-center gap-2 -mt-1.5">
                        <span className="italic font-titleFont font-extrabold text-base">
                        !
                        </span>
                        {firebaseErr}
                    </p>
                    )}
                </div>
                <div className="flex flex-col gap-2">
                    <p className="text-sm font-medium">Password</p>
                    <input
                    value={password}
                    onChange={handlePassword}
                    type="password"
                    className="w-full py-1 border border-zinc-400 px-2 text-base rounded-sm outline-none focus-within:border-[#e77600] focus-within:shadow-amazonInput duration-100"
                    />
                    {errPassword && (
                    <p className="text-red-600 text-xs font-semibold tracking-wide flex items-center gap-2 -mt-1.5">
                        <span className="italic font-titleFont font-extrabold text-base">
                        !
                        </span>
                        {errPassword}
                    </p>
                    )}
                </div>
                <div className="flex flex-col gap-2">
                    <p className="text-sm font-medium">Re-enter Password</p>
                    <input
                    onChange={handleCPassword}
                    value={confirmPassword}
                    type="password"
                    className="w-full py-1 border border-zinc-400 px-2 text-base rounded-sm outline-none focus-within:border-[#e77600] focus-within:shadow-amazonInput duration-100"
                    />
                    {errConfirmPassword && (
                    <p className="text-red-600 text-xs font-semibold tracking-wide flex items-center gap-2 -mt-1.5">
                        <span className="italic font-titleFont font-extrabold text-base">
                        !
                        </span>
                        {errConfirmPassword}
                    </p>
                    )}
                    <p className="text-xs text-gray-600">
                    Passwords must be at least 6 characters.
                    </p>
                </div>
                <button
                    onClick={handleRegistration}
                    className="w-full py-1.5 text-sm font-normal rounded-sm bg-gradient-to-t from-[#f7dfa5] to-[#f0c14b] hover:bg-gradient-to-b border border-zinc-400 active:border-yellow-800 active:shadow-amazonInput"
                >
                    Continue
                </button>
                {
                    loading && (
                        <div className="flex justify-center">
                            <RotatingLines
                                strokeColor="#FEBD69"
                                strokeWidth="5"
                                animationDuration="0.75"
                                width="50"
                                visible={true}
                            />
                        </div>
                    )
                }
                {
                    successMsg && (
                        <div>
                            <motion.p
                                initial={{ y: 10, opacity: 0 }}
                                animate={{ y: 0, opacity: 1 }}
                                transition={{ duration: 0.5 }}
                                className='text-base font-titleFont font-semibold text-green-500 border-[1px] border-green-500 px-2 text-center'
                                >
                                    {successMsg}
                            </motion.p>
                        </div>
                    )
                }
                </div>
                <p className="text-xs text-black leading-4 mt-4">
                By Continuing, you agree to Amazon's{" "}
                <span className="text-blue-600">Conditions of Use </span>and{" "}
                <span className="text-blue-600">Privace Notice.</span>
                </p>
                <div>
                <p className="text-xs text-black">
                    Already have an account?{" "}
                    <Link to="/signin">
                    <span className="text-xs text-blue-600 hover:text-orange-600 hover:underline underline-offset-1 cursor-pointer duration-100">
                        Sign in{" "}
                        <span>
                        <ArrowRightIcon />
                        </span>
                    </span>
                    </Link>
                </p>
                <p className="text-xs text-black -mt-2">
                    Buying for work?{" "}
                    <span className="text-xs text-blue-600 hover:text-orange-600 hover:underline underline-offset-1 cursor-pointer duration-100">
                    Create a free business account
                    </span>
                </p>
                </div>
            </div>
            </form>
        </div>
        <div className="w-full bg-gradient-to-t from-white via-white to-zinc-200 flex flex-col gap-4 justify-center items-center py-10">
            <div className="flex items-center gap-6">
            <p className="text-xs text-blue-600 hover:text-orange-600 hover:underline underline-offset-1 cursor-pointer duration-100">
                Conditions of Use
            </p>
            <p className="text-xs text-blue-600 hover:text-orange-600 hover:underline underline-offset-1 cursor-pointer duration-100">
                Privacy Notice
            </p>
            <p className="text-xs text-blue-600 hover:text-orange-600 hover:underline underline-offset-1 cursor-pointer duration-100">
                Privacy Notice
            </p>
            </div>
            <p className="text-xs text-gray-600">
            © 1996-2023, ReactBd.com, Inc. or its affiliates
            </p>
        </div>
        </div>
    );
};

export default Registration;